import React from 'react';

import './styles.scss';

const FiltersMbSection = ({ filterTabActive, handleFilterTab }) => (
  <ul className="filtersMobSec">
    <li
      className={filterTabActive === 'filter' ? 'active' : ''}
      onClick={() => handleFilterTab('filter')}
    >
      <span>Filters</span>
      <span className="icon mmt-filter" />
    </li>
  </ul>
);

export default FiltersMbSection;
